// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; // ✅ Import Storage
import { loadGraphModel } from '@tensorflow/tfjs-converter';  // Import Firebase ML

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBR-CzqT3QXkmkDzNeqAtb9LVtfrdJ2j2c",
  authDomain: "mango-bcf17.firebaseapp.com",
  projectId: "mango-bcf17",
  storageBucket: "mango-bcf17.appspot.com", // ✅ Fixed this
  messagingSenderId: "504947842650",
  appId: "1:504947842650:web:d4c4e92d33d20d89acc263",
  measurementId: "G-0JTQC98SF7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Export the Firebase modules for use
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
const tf = window.tf;
// Export TensorFlow.js and TensorFlow.js Converter
export async function loadMyModel(modelUrl) {
  try {
      const model = await tf.loadGraphModel(modelUrl);
      return model;
  } catch (error) {
      console.error("Error loading model:", error);
      return null;
  }
} // Export the auth instance

// ✅ If you want to use analytics, uncomment the line below:
// import { getAnalytics } from "firebase/analytics";
// const analytics = getAnalytics(app);
